import { Model } from '@nozbe/watermelondb'
import { field, date, json } from '@nozbe/watermelondb/decorators'
import { Q } from '@nozbe/watermelondb';
import { toRaw } from './utils';

export const CommentColumns = [
    { name: 'commentable_type', type: 'string', isOptional: true },
    { name: 'commentable_id', type: 'string', isOptional: true },
    { name: 'user_id', type: 'string', isOptional: true },
    { name: 'body', type: 'string', isOptional: true },
    { name: 'meta', type: 'string', isOptional: true, isJson: true },
    { name: 'is_revision', type: 'number' },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
]

export class Comment extends Model {
    static table = 'comment'
    
    @field('commentable_type') commentableType
    @field('commentable_id') commentableId
    @field('user_id') userId
    @field('body') body
    @json('meta', j => j) meta
    @field('is_revision') isRevision
    @date('created_at') createdAt
    @date('updated_at') updatedAt

    toRaw = toRaw.bind(this, CommentColumns);
}